<template>
  <el-table :data="tableData" class="w-100" >
    <el-table-column :prop="dataItem.prop" :label="dataItem.label" :width="dataItem.w"
                     v-for="(dataItem,index) in tableColumn" :key="index"/>
  </el-table>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'TravelTable',
    data() {
      return {
        tableColumn: [
          {prop: 'name', label: '门店类型', w: 100},
          {prop: 'sendOrderNum', label: '发布订单', w: 100},
          {prop: 'transactionOrderNum', label: '成交订单', w: 100},
          {prop: 'transactionOrderMoney', label: '成交金额(元)', w: 100},
          {prop: 'offerHotelNum', label: '报价酒店数量', w: 120},
          {prop: 'transactionHotelNum', label: '成交酒店数量', w: 120},
          {prop: 'receivePeopleNum', label: '接待人次', w: 120},
          {prop: 'payMoney', label: '实际付款金额(元)', w: 140},
        ]
      }
    },
    computed: {
      ...mapState(['StoreChartLists']),
      tableData() {
        if (!$.isArray(this.StoreChartLists)) return [];
        return this.StoreChartLists.map(item => {
          if (item.transactionOrderMoney) item.transactionOrderMoney = item.transactionOrderMoney / 100;
          if (item.payMoney)  item.payMoney = item.payMoney / 100;
          return item;
        })
      }
    }
  }
</script>
